import Logo from './Logo';

function LogoWithText({ size = 'md', showTagline = false, className = '' }) {
  const textSizes = {
    sm: { title: 'text-lg', tagline: 'text-xs' },
    md: { title: 'text-xl', tagline: 'text-xs' },
    lg: { title: 'text-3xl', tagline: 'text-sm' },
    xl: { title: 'text-4xl', tagline: 'text-base' }
  };

  const textSize = textSizes[size] || textSizes.md;

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <Logo size={size} />
      <div>
        <h1 className={`${textSize.title} font-heading font-bold text-slate-900 leading-none`}>
          Expense Flow for Small Biz
        </h1>
        {showTagline && (
          <p className={`${textSize.tagline} text-slate-500 mt-0.5`}>
            Invoice Management
          </p>
        )}
      </div>
    </div>
  );
}

export default LogoWithText;